import { useMutation, useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { TeeBookingPlayer } from '../../database.schema';

type TeeBookingData = {
  players: Array<TeeBookingPlayer>;
};

const mutateTeeBookingPlayersData = async (playerData: TeeBookingData): Promise<TeeBookingData> => {
  const authToken = Cookies.get('token');
  var dbDNS = `https://golf-tour-462cf-default-rtdb.europe-west1.firebasedatabase.app/teeTimeBooking/.json?auth=${authToken}`;
  if (process.env.REACT_APP_MODE === 'dev') {
    dbDNS = `http://127.0.0.1:9000/teeTimeBooking/.json?ns=golf-tour-462cf-default-rtdb&auth=${authToken}`;
  }
  const response = await fetch(dbDNS, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify([...playerData.players]),
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return await response.json();
};

export const useTeeBookingPlayersMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: mutateTeeBookingPlayersData,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ['all-data'] });
    },
    onError: (error) => {
      console.log('error', error);
    },
  });
};
